{
  "HELP_CENTER": {
    "TITLE": "Qendra e Ndihmës",
    "NEW_PAGE": {
      "DESCRIPTION": "Krijoni portale ndihme me vetëshërbim për klientët tuaj. Ndihmojini të gjejnë përgjigje shpejt, pa pritur. Thjeshtoni kërkesat, rrisni efikasitetin e agjentëve dhe përmirësoni mbështetjen ndaj klientit.",
      "CREATE_PORTAL_BUTTON": "Krijo Portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Pa titull"
    },
    "HEADER": {
      "FILTER": "Filtro sipas",
      "SORT": "Rendit sipas",
      "LOCALE": "Gjuha",
      "SETTINGS_BUTTON": "Cilësimet",
      "NEW_BUTTON": "Artikull i ri",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publikuar",
        "DRAFT": "Draft",
        "ARCHIVED": "Arkivuar"
      },
      "TITLES": {
        "ALL_ARTICLES": "Të gjithë artikujt",
        "MINE": "Artikujt e mi",
        "DRAFT": "Artikuj Draft",
        "ARCHIVED": "Artikuj të arkivuar"
      },
      "LOCALE_SELECT": {
        "TITLE": "Zgjidh gjuhën",
        "PLACEHOLDER": "Zgjidh gjuhën",
        "NO_RESULT": "Nuk u gjet asnjë gjuhë",
        "SEARCH_PLACEHOLDER": "Kërko gjuhën"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Të gjithë artikujt",
      "PUBLISH_BUTTON": "Publiko",
      "MOVE_TO_ARCHIVE_BUTTON": "Kalo në të arkivuara",
      "PREVIEW": "Pamja paraprake",
      "ADD_TRANSLATION": "Shto përkthim",
      "OPEN_SIDEBAR": "Hap panelin anësor",
      "CLOSE_SIDEBAR": "Mbyll panelin anësor",
      "SAVING": "Duke ruajtur...",
      "SAVED": "U ruajt"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Ngarko imazh",
        "UPLOADING": "Po ngarkohet...",
        "SUCCESS": "Imazhi u ngarkua me sukses",
        "ERROR": "Gabim gjatë ngarkimit të imazhit",
        "UN_AUTHORIZED_ERROR": "Nuk keni autorizim për të ngarkuar imazhe",
        "ERROR_FILE_SIZE": "Madhësia e imazhit duhet të jetë më e vogël se {size}MB",
        "ERROR_FILE_FORMAT": "Formati i imazhit duhet të jetë jpg, jpeg ose png",
        "ERROR_FILE_DIMENSIONS": "Përmasat e imazhit duhet të jenë më të vogla se 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Fut spirancë",
        "TITLE": "Fut spirancë",
        "SUBMIT": "Fut",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Cilësimet e artikullit",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategoria",
          "TITLE": "Zgjidh kategorinë",
          "PLACEHOLDER": "Zgjidh kategorinë",
          "NO_RESULT": "Nuk u gjet asnjë kategori",
          "SEARCH_PLACEHOLDER": "Kërko kategorinë"
        },
        "AUTHOR": {
          "LABEL": "Autori",
          "TITLE": "Zgjidh autorin",
          "PLACEHOLDER": "Zgjidh autorin",
          "NO_RESULT": "Nuk u gjet asnjë autor",
          "SEARCH_PLACEHOLDER": "Kërko autorin"
        },
        "META_TITLE": {
          "LABEL": "Titulli meta",
          "PLACEHOLDER": "Shto një titull meta"
        },
        "META_DESCRIPTION": {
          "LABEL": "Përshkrimi meta",
          "PLACEHOLDER": "Shto përshkrimin tënd meta për rezultate më të mira SEO..."
        },
        "META_TAGS": {
          "LABEL": "Etiketat meta",
          "PLACEHOLDER": "Shto etiketa meta të ndara me presje..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arkivo artikullin",
        "DELETE": "Fshi artikullin"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Pa kategori",
      "SEARCH_RESULTS": "Rezultatet e kërkimit për {query}",
      "EMPTY_TEXT": "Kërko artikuj për t'i futur në përgjigje.",
      "SEARCH_LOADER": "Duke kërkuar...",
      "INSERT_ARTICLE": "Fut",
      "NO_RESULT": "Nuk u gjet asnjë artikull",
      "COPY_LINK": "Kopjo lidhjen e artikullit",
      "OPEN_LINK": "Hap artikullin në skedë të re",
      "PREVIEW_LINK": "Shiko paraprakisht artikullin"
    },
    "PORTAL": {
      "HEADER": "Portalet",
      "DEFAULT": "Parazgjedhje",
      "NEW_BUTTON": "Portal i ri",
      "ACTIVE_BADGE": "aktiv",
      "CHOOSE_LOCALE_LABEL": "Zgjidh një gjuhë",
      "LOADING_MESSAGE": "Duke ngarkuar portalet...",
      "ARTICLES_LABEL": "artikuj",
      "NO_PORTALS_MESSAGE": "Nuk ka portale të disponueshme",
      "ADD_NEW_LOCALE": "Shto një gjuhë të re",
      "POPOVER": {
        "TITLE": "Portalet",
        "PORTAL_SETTINGS": "Cilësimet e portalit",
        "SUBTITLE": "Ke disa portale dhe mund të kesh gjuhë të ndryshme për secilin portal.",
        "CANCEL_BUTTON_LABEL": "Anulo",
        "CHOOSE_LOCALE_BUTTON": "Zgjidh gjuhën"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "artikuj",
            "ADD": "Shto gjuhë",
            "VISIT": "Vizito faqen",
            "SETTINGS": "Cilësimet",
            "DELETE": "Fshi"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Konfigurimet e portalit",
            "ITEMS": {
              "NAME": "Emri",
              "DOMAIN": "Domeni i personalizuar",
              "SLUG": "Slug",
              "TITLE": "Titulli i portalit",
              "THEME": "Ngjyra e temës",
              "SUB_TEXT": "Nëntekst i portalit"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Gjuhët e disponueshme",
            "TABLE": {
              "NAME": "Emri i gjuhës",
              "CODE": "Kodi i gjuhës",
              "ARTICLE_COUNT": "Nr. i artikujve",
              "CATEGORIES": "Nr. i kategorive",
              "SWAP": "Shkëmbe",
              "DELETE": "Fshi",
              "DEFAULT_LOCALE": "Parazgjedhje"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Fshi portalin",
          "MESSAGE": "Je i sigurt që dëshiron ta fshish këtë portal",
          "YES": "Po, fshi portalin",
          "NO": "Jo, mbaje portalin",
          "API": {
            "DELETE_SUCCESS": "Portali u fshi me sukses",
            "DELETE_ERROR": "Gabim gjatë fshirjes së portalit"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Modifiko portalin",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Informacion bazë"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Personalizimi i portalit"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategoritë"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Gjuhët"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategoritë në",
          "NEW_CATEGORY": "Kategori e re",
          "TABLE": {
            "NAME": "Emri",
            "DESCRIPTION": "Përshkrimi",
            "LOCALE": "Gjuha",
            "ARTICLE_COUNT": "Nr. i artikujve",
            "ACTION_BUTTON": {
              "EDIT": "Modifiko kategorinë",
              "DELETE": "Fshi kategorinë"
            },
            "EMPTY_TEXT": "Nuk u gjet asnjë kategori"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Përditëso cilësimet bazë"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informacioni i qendrës së ndihmës",
            "BODY": "Informacion bazë rreth portalit"
          },
          "CUSTOMIZATION": {
            "TITLE": "Personalizimi i qendrës së ndihmës",
            "BODY": "Personalizo portalin"
          },
          "FINISH": {
            "TITLE": "Voila! 🎉",
            "BODY": "Gjithçka është gati!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Prapa",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Krijo Portal",
            "TITLE": "Informacioni i qendrës së ndihmës",
            "CREATE_BASIC_SETTING_BUTTON": "Krijo cilësimet bazë të portalit"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Personalizimi i portalit",
            "TITLE": "Personalizimi i qendrës së ndihmës",
            "UPDATE_PORTAL_BUTTON": "Përditëso cilësimet e portalit"
          },
          "FINISH_PAGE": {
            "TITLE": "Voila!🎉 Gjithçka është gati!",
            "MESSAGE": "Tani mund ta shohësh portalin e krijuar te faqja e të gjitha portaleve.",
            "FINISH": "Shko te faqja e të gjitha portaleve"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Ngarko logon",
          "HELP_TEXT": "Kjo logo do të shfaqet në krye të portalit.",
          "IMAGE_UPLOAD_SUCCESS": "Logo u ngarkua me sukses",
          "IMAGE_UPLOAD_ERROR": "Logo u fshi me sukses",
          "IMAGE_DELETE_ERROR": "Gabim gjatë fshirjes së logos"
        },
        "NAME": {
          "LABEL": "Emri",
          "PLACEHOLDER": "Emri i portalit",
          "HELP_TEXT": "Emri do të përdoret brenda portalit publik.",
          "ERROR": "Emri është i detyrueshëm"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug i portalit për URL-të",
          "ERROR": "Slug është i detyrueshëm"
        },
        "DOMAIN": {
          "LABEL": "Domen i personalizuar",
          "PLACEHOLDER": "Domeni i personalizuar i portalit",
          "HELP_TEXT": "Shto vetëm nëse dëshiron të përdorësh një domen të personalizuar për portalet e tua. P.sh.: {exampleURL}",
          "ERROR": "Vendos një URL domeni të vlefshme"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Lidhja e faqes kryesore",
          "PLACEHOLDER": "Lidhja e faqes kryesore të portalit",
          "HELP_TEXT": "Lidhja e përdorur për t'u kthyer nga portali te faqja kryesore. P.sh.: {exampleURL}",
          "ERROR": "Vendos një URL të vlefshme për faqen kryesore"
        },
        "THEME_COLOR": {
          "LABEL": "Ngjyra e temës së portalit",
          "HELP_TEXT": "Kjo ngjyrë do të shfaqet si ngjyra e temës për portalin."
        },
        "PAGE_TITLE": {
          "LABEL": "Titulli i faqes",
          "PLACEHOLDER": "Titulli i faqes së portalit",
          "HELP_TEXT": "Titulli i faqes do të përdoret në portalin publik.",
          "ERROR": "Titulli i faqes është i detyrueshëm"
        },
        "HEADER_TEXT": {
          "LABEL": "Teksti i krye",
          "PLACEHOLDER": "Teksti i krye i portalit",
          "HELP_TEXT": "Teksti i krye i portalit do të përdoret në portalin publik.",
          "ERROR": "Teksti i krye i portalit është i detyrueshëm"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portali u krijua me sukses.",
          "ERROR_MESSAGE_FOR_BASIC": "Portali nuk u krijua dot. Provo përsëri.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portali u përditësua me sukses.",
          "ERROR_MESSAGE_FOR_UPDATE": "Portali nuk u përditësua dot. Provo përsëri."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Shto një gjuhë të re",
        "SUB_TITLE": "Kjo shton një gjuhë të re në listën tënde të përkthimeve të disponueshme.",
        "PORTAL": "Portali",
        "LOCALE": {
          "LABEL": "Gjuha",
          "PLACEHOLDER": "Zgjidh një gjuhë",
          "ERROR": "Gjuha është e detyrueshme"
        },
        "BUTTONS": {
          "CREATE": "Krijo gjuhën",
          "CANCEL": "Anulo"
        },
        "API": {
          "SUCCESS_MESSAGE": "Gjuha u shtua me sukses",
          "ERROR_MESSAGE": "Gjuha nuk u shtua dot. Provo përsëri."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Gjuha e parazgjedhur u përditësua me sukses",
          "ERROR_MESSAGE": "Gjuha e parazgjedhur nuk u përditësua dot. Provo përsëri."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Gjuha u hoq nga portali me sukses",
          "ERROR_MESSAGE": "Gjuha nuk u hoq dot nga portali. Provo përsëri."
        }
      }
    },
    "TABLE": {
      "404": "Asnjë artikull nuk përputhet me kërkimin tënd 🔍",
      "LOADING_MESSAGE": "Duke ngarkuar artikujt...",
      "NO_ARTICLES": "Nuk ka artikuj të disponueshëm",
      "HEADERS": {
        "TITLE": "Titulli",
        "CATEGORY": "Kategoria",
        "READ_COUNT": "Shikime",
        "STATUS": "Statusi",
        "LAST_EDITED": "Modifikuar së fundmi"
      },
      "COLUMNS": {
        "BY": "nga",
        "AUTHOR_NOT_AVAILABLE": "Autori nuk është i disponueshëm"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Duke ngarkuar artikullin...",
      "TITLE_PLACEHOLDER": "Titulli i artikullit këtu",
      "CONTENT_PLACEHOLDER": "Shkruaj artikullin tënd këtu",
      "API": {
        "ERROR": "Gabim gjatë ruajtjes së artikullit"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Gabim gjatë publikimit të artikullit",
        "SUCCESS": "Artikulli u publikua me sukses"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Gabim gjatë arkivimit të artikullit",
        "SUCCESS": "Artikulli u arkivua me sukses"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Gabim gjatë kalimit të artikullit në Draft",
        "SUCCESS": "Artikulli u kalua në Draft me sukses"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Konfirmo fshirjen",
          "MESSAGE": "Je i sigurt që dëshiron ta fshish artikullin?",
          "YES": "Po, fshi",
          "NO": "Jo, mbaje"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artikulli u fshi me sukses",
        "ERROR_MESSAGE": "Gabim gjatë fshirjes së artikullit"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Ju lutemi shtoni titullin dhe përmbajtjen e artikullit; vetëm atëherë mund të përditësoni cilësimet"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Kërko artikuj"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Krijo një kategori",
        "SUB_TITLE": "Kategoria do të përdoret në portalin publik për të kategorizuar artikujt.",
        "PORTAL": "Portali",
        "LOCALE": "Gjuha",
        "NAME": {
          "LABEL": "Emri",
          "PLACEHOLDER": "Emri i kategorisë",
          "HELP_TEXT": "Emri dhe ikona e kategorisë do të përdoren në portalin publik për të kategorizuar artikujt.",
          "ERROR": "Emri është i detyrueshëm"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug i kategorisë për URL-të",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug është i detyrueshëm"
        },
        "DESCRIPTION": {
          "LABEL": "Përshkrimi",
          "PLACEHOLDER": "Jep një përshkrim të shkurtër për kategorinë.",
          "ERROR": "Përshkrimi është i detyrueshëm"
        },
        "BUTTONS": {
          "CREATE": "Krijo kategorinë",
          "CANCEL": "Anulo"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategoria u krijua me sukses",
          "ERROR_MESSAGE": "Kategoria nuk u krijua dot"
        }
      },
      "EDIT": {
        "TITLE": "Modifiko një kategori",
        "SUB_TITLE": "Modifikimi i një kategorie do të përditësojë kategorinë në portalin publik.",
        "PORTAL": "Portali",
        "LOCALE": "Gjuha",
        "NAME": {
          "LABEL": "Emri",
          "PLACEHOLDER": "Emri i kategorisë",
          "HELP_TEXT": "Emri dhe ikona e kategorisë do të përdoren në portalin publik për të kategorizuar artikujt.",
          "ERROR": "Emri është i detyrueshëm"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug i kategorisë për URL-të",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug është i detyrueshëm"
        },
        "DESCRIPTION": {
          "LABEL": "Përshkrimi",
          "PLACEHOLDER": "Jep një përshkrim të shkurtër për kategorinë.",
          "ERROR": "Përshkrimi është i detyrueshëm"
        },
        "BUTTONS": {
          "CREATE": "Përditëso kategorinë",
          "CANCEL": "Anulo"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategoria u përditësua me sukses",
          "ERROR_MESSAGE": "Kategoria nuk u përditësua dot"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategoria u fshi me sukses",
          "ERROR_MESSAGE": "Kategoria nuk u fshi dot"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Kërko artikuj",
      "PLACEHOLDER": "Kërko artikuj",
      "NO_RESULT": "Nuk u gjet asnjë artikull",
      "SEARCHING": "Duke kërkuar...",
      "SEARCH_BUTTON": "Kërko",
      "INSERT_ARTICLE": "Fut lidhjen",
      "IFRAME_ERROR": "URL-ja është bosh ose e pavlefshme. Përmbajtja nuk mund të shfaqet.",
      "OPEN_ARTICLE_SEARCH": "Fut artikull nga Qendra e Ndihmës",
      "SUCCESS_ARTICLE_INSERTED": "Artikulli u fut me sukses",
      "PREVIEW_LINK": "Shiko paraprakisht artikullin",
      "CANCEL": "Mbyll",
      "BACK": "Prapa",
      "BACK_RESULTS": "Kthehu te rezultatet"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Qendra e Ndihmës",
      "DESCRIPTION": "Krijoni portale vetëshërbimi miqësore për përdoruesit. Ndihmojini përdoruesit tuaj të kenë qasje në artikuj dhe të marrin mbështetje 24/7. Përmirësoni abonimin tuaj për të aktivizuar këtë veçori.",
      "SELF_HOSTED_DESCRIPTION": "Krijoni portale vetëshërbimi miqësore për përdoruesit. Ndihmojini përdoruesit tuaj të kenë qasje në artikuj dhe të marrin mbështetje 24/7. Ju lutemi kontaktoni administratorin tuaj për të aktivizuar këtë veçori.",
      "BUTTON": {
        "LEARN_MORE": "Mëso më shumë",
        "UPGRADE": "Përmirëso"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Portale të shumëfishta",
          "DESCRIPTION": "Krijo disa portale të qendrës së ndihmës për produkte të ndryshme duke përdorur të njëjtën llogari."
        },
        "LOCALES": {
          "TITLE": "Mbështetje e plotë për gjuhët",
          "DESCRIPTION": "Përshtat portalin në gjuhën tënde. Mbështesim të gjitha gjuhët dhe lejojmë përkthime për çdo artikull."
        },
        "SEO": {
          "TITLE": "Dizajn miqësor për SEO",
          "DESCRIPTION": "Personalizo etiketat meta për të përmirësuar dukshmërinë tënde në motorët e kërkimit me faqet tona miqësore për SEO."
        },
        "API": {
          "TITLE": "Mbështetje e plotë për API",
          "DESCRIPTION": "Përdor portalin si një CMS pa ndërfaqe (headless) me korniza front-end të palëve të treta duke përdorur API-t tona."
        }
      }
    },
    "LOADING": "Duke ngarkuar...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} shikim | {count} shikime",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publiko",
            "DRAFT": "Draft",
            "ARCHIVE": "Arkivo",
            "DELETE": "Fshi"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Publikuar",
            "ARCHIVED": "Arkivuar"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Pa kategori"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Të gjithë artikujt",
          "MINE": "Të mitë",
          "DRAFT": "Draft",
          "PUBLISHED": "Publikuar",
          "ARCHIVED": "Arkivuar"
        },
        "CATEGORY": {
          "ALL": "Të gjitha kategoritë"
        },
        "LOCALE": {
          "ALL": "Të gjitha gjuhët"
        },
        "NEW_ARTICLE": "Artikull i ri"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Shkruaj një artikull",
          "SUBTITLE": "Shkruaj një artikull të pasur, le të fillojmë!",
          "BUTTON_LABEL": "Artikull i ri"
        },
        "MINE": {
          "TITLE": "Nuk ke shkruar asnjë artikull këtu",
          "SUBTITLE": "Të gjithë artikujt e shkruar nga ti shfaqen këtu për qasje të shpejtë."
        },
        "DRAFT": {
          "TITLE": "Nuk ka artikuj në Draft",
          "SUBTITLE": "Artikujt Draft do të shfaqen këtu"
        },
        "PUBLISHED": {
          "TITLE": "Nuk ka artikuj të publikuar",
          "SUBTITLE": "Artikujt e publikuar do të shfaqen këtu"
        },
        "ARCHIVED": {
          "TITLE": "Nuk ka artikuj në arkiv",
          "SUBTITLE": "Artikujt e arkivuar nuk shfaqen në portal, mund t'i përdorësh për të shënuar faqe të vjetruara ose jashtë përdorimit"
        },
        "CATEGORY": {
          "TITLE": "Nuk ka artikuj në këtë kategori",
          "SUBTITLE": "Artikujt e kësaj kategorie do të shfaqen këtu"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Kategori e re",
        "EDIT_CATEGORY": "Modifiko kategorinë",
        "CATEGORIES_COUNT": "{n} kategori | {n} kategori",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategoritë ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} artikuj) | {categoryName} ({categoryCount} artikull)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nuk u gjet asnjë kategori",
        "SUBTITLE": "Kategoritë do të shfaqen këtu. Mund të shtosh një kategori duke klikuar butonin 'Kategori e re'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} artikull | {count} artikuj",
        "EXPAND": "Shfaq nënkategoritë",
        "COLLAPSE": "Fshih nënkategoritë",
        "MENU": {
          "NEW_ARTICLE": "Artikull i ri",
          "ADD_SUBCATEGORY": "Shto nënkategori",
          "EDIT": "Modifiko",
          "DELETE": "Fshi"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria u krijua me sukses",
            "ERROR_MESSAGE": "Kategoria nuk u krijua dot"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria u përditësua me sukses",
            "ERROR_MESSAGE": "Kategoria nuk u përditësua dot"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria u fshi me sukses",
            "ERROR_MESSAGE": "Kategoria nuk u fshi dot"
          },
          "CONFIRM": {
            "TITLE": "Fshi kategorinë",
            "DESCRIPTION": "Je i sigurt që dëshiron ta fshish këtë kategori? Artikujt e saj do të bëhen pa kategori.",
            "DESCRIPTION_WITH_CHILDREN": "Je i sigurt që dëshiron ta fshish këtë kategori? Artikujt e saj do të bëhen pa kategori dhe {count} nënkategori e saj do të zhvendoset në nivelin kryesor. | Je i sigurt që dëshiron ta fshish këtë kategori? Artikujt e saj do të bëhen pa kategori dhe {count} nënkategoritë e saj do të zhvendosen në nivelin kryesor.",
            "CONFIRM": "Fshi"
          }
        },
        "HEADER": {
          "CREATE": "Krijo kategori",
          "EDIT": "Modifiko kategorinë",
          "DESCRIPTION": "Modifikimi i një kategorie do të përditësojë kategorinë në portalin publik.",
          "PORTAL": "Portali",
          "LOCALE": "Gjuha"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Emri",
            "PLACEHOLDER": "Emri i kategorisë",
            "ERROR": "Emri është i detyrueshëm"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug i kategorisë për URL-të",
            "ERROR": "Slug është i detyrueshëm",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Përshkrimi",
            "PLACEHOLDER": "Jep një përshkrim të shkurtër për kategorinë.",
            "ERROR": "Përshkrimi është i detyrueshëm"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Kategoria prind",
            "PLACEHOLDER": "Zgjidh një kategori prind",
            "NONE": "Asnjë (niveli kryesor)"
          }
        },
        "BUTTONS": {
          "CREATE": "Krijo",
          "EDIT": "Përditëso",
          "CANCEL": "Anulo"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Nuk ka gjuhë të disponueshme | {n} gjuhë | {n} gjuhë",
      "NEW_LOCALE_BUTTON_TEXT": "Gjuhë e re",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} artikull | {count} artikuj",
        "CATEGORIES_COUNT": "{count} kategori | {count} kategori",
        "DEFAULT": "Parazgjedhje",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Bëje parazgjedhje",
          "DELETE": "Fshi"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Shto një gjuhë të re",
        "DESCRIPTION": "Zgjidh gjuhën në të cilën do të shkruhet ky artikull. Kjo do të shtohet në listën tënde të përkthimeve dhe mund të shtosh të tjera më vonë.",
        "COMBOBOX": {
          "PLACEHOLDER": "Zgjidh gjuhën..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Gjuha u shtua me sukses",
          "ERROR_MESSAGE": "Gjuha nuk u shtua dot. Provo përsëri."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Duke ruajtur...",
          "SAVED": "U ruajt"
        },
        "PREVIEW": "Pamja paraprake",
        "PUBLISH": "Publiko",
        "DRAFT": "Draft",
        "ARCHIVE": "Arkivo",
        "BACK_TO_ARTICLES": "Kthehu te artikujt"
      },
      "DRAFT": {
        "PENDING_LABEL": "Ndryshime të papublikuara",
        "PROMOTE": "Publiko ndryshimet",
        "DISCARD": "Hidh ndryshimet",
        "PROMOTE_SUCCESS": "Ndryshimet Draft u publikuan në artikullin aktual",
        "PROMOTE_ERROR": "Ndryshimet Draft nuk u publikuan dot",
        "DISCARD_SUCCESS": "Ndryshimet Draft u hodhën poshtë",
        "DISCARD_ERROR": "Ndryshimet Draft nuk u hodhën dot poshtë"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Historiku i versioneve",
        "TITLE": "Historiku i versioneve",
        "BACK": "Kthehu te artikulli",
        "LOADING": "Duke ngarkuar versionet...",
        "EMPTY": "Ende nuk ka versione. Ndryshimet e këtij artikulli do të shfaqen këtu.",
        "EMPTY_CONTENT": "Ky version nuk ka përmbajtje.",
        "CURRENT_BADGE": "Aktual",
        "RESTORED_BADGE": "Rikthyer",
        "AUTOMATED_USER": "Përditësim automatik",
        "RESTORE": "Rikthe këtë version",
        "RESTORE_DIALOG": {
          "TITLE": "Rikthe këtë version?",
          "DESCRIPTION": "Artikulli do të kthehet te teksti i këtij versioni. Asgjë nuk humbet — teksti aktual mbetet në historik, dhe artikulli i publikuar do të vazhdojë të shfaqë versionin aktual derisa të publikosh ndryshimin.",
          "CONFIRM": "Rikthe"
        },
        "RESTORE_SUCCESS": "Versioni u rikthye",
        "RESTORE_ERROR": "Ky version nuk u rikthye dot",
        "FETCH_ERROR": "Historiku i versioneve nuk u ngarkua dot"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Më shumë veti",
        "TRANSLATE": "Përkthe",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Pa kategori",
        "EDITOR_PLACEHOLDER": "Shkruaj diçka...",
        "HTML_EMBED": {
          "TITLE": "Fut HTML të personalizuar",
          "DESCRIPTION": "Ngjit HTML të papërpunuar si një iframe, embed ose copëz widget-i. Do të shfaqet ashtu siç është në artikullin e publikuar.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Fut"
        },
        "PRIMARY_CATEGORY": "Kategoria kryesore"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Vetitë e artikullit",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Përshkrimi meta",
        "META_DESCRIPTION_PLACEHOLDER": "Shto përshkrimin meta",
        "META_TITLE": "Titulli meta",
        "META_TITLE_PLACEHOLDER": "Shto titullin meta",
        "META_TAGS": "Etiketat meta",
        "META_TAGS_PLACEHOLDER": "Shto etiketa meta",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Mutacionet gjuhësore",
        "LANGUAGE_MUTATIONS_EMPTY": "Ende nuk ka artikuj të lidhur",
        "ADD_MUTATION": "Shto",
        "REMOVE_MUTATION": "Hiq"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Lidh mutacionet gjuhësore",
        "SEARCH_PLACEHOLDER": "Kërko artikuj sipas titullit",
        "EMPTY": "Nuk ka artikuj që përputhen",
        "CANCEL": "Anulo",
        "ADD_SELECTED": "Shto të zgjedhurit",
        "SUCCESS": "Mutacionet u përditësuan",
        "ERROR": "Përditësimi i mutacioneve dështoi"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Përkthe artikullin",
        "DESCRIPTION": "Zgjidh gjuhët në të cilat dëshiron ta përkthesh këtë artikull. Gjuhët që janë përkthyer tashmë do të ripërkthehen në një Draft për shqyrtim.",
        "EMPTY": "Nuk ka gjuhë të tjera të disponueshme",
        "CONNECTED_BADGE": "Përkthyer",
        "CANCEL": "Anulo",
        "TRANSLATE": "Përkthe",
        "SUCCESS": "Përkthimi do të fillojë së shpejti. Artikujt e përkthyer do të shfaqen së shpejti si mutacione gjuhësore.",
        "ERROR": "Dështoi nisja e përkthimit"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Gabim gjatë ruajtjes së artikullit"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Portal i ri",
      "PORTALS": "Portalet",
      "CREATE_PORTAL": "Krijo dhe menaxho disa portale",
      "ARTICLES": "artikuj",
      "DOMAIN": "domeni",
      "PORTAL_NAME": "Emri i portalit"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Krijo portal të ri",
      "DESCRIPTION": "Jepi portalit tënd një emër dhe krijo një slug URL miqësor. Mund t'i modifikosh të dyja më vonë te cilësimet.",
      "CONFIRM_BUTTON_LABEL": "Krijo",
      "NAME": {
        "LABEL": "Emri",
        "PLACEHOLDER": "Udhëzues përdoruesi",
        "MESSAGE": "Zgjidh një emër për portalin tënd.",
        "ERROR": "Emri është i detyrueshëm"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug është i detyrueshëm",
        "FORMAT_ERROR": "Përdorni vetëm shkronja, numra dhe viza, për shembull: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Imazhi nuk u ngarkua dot! Provo përsëri",
          "IMAGE_UPLOAD_SUCCESS": "Imazhi u shtua me sukses. Kliko te ruaj ndryshimet për të ruajtur logon",
          "IMAGE_DELETE_SUCCESS": "Logo u fshi me sukses",
          "IMAGE_DELETE_ERROR": "Logo nuk u fshi dot",
          "IMAGE_UPLOAD_SIZE_ERROR": "Madhësia e imazhit duhet të jetë më e vogël se {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Emri",
          "PLACEHOLDER": "Emri i portalit",
          "ERROR": "Emri është i detyrueshëm"
        },
        "HEADER_TEXT": {
          "LABEL": "Teksti i krye",
          "PLACEHOLDER": "Teksti i krye i portalit"
        },
        "PAGE_TITLE": {
          "LABEL": "Titulli i faqes",
          "PLACEHOLDER": "Titulli i faqes së portalit"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Lidhja e faqes kryesore",
          "PLACEHOLDER": "Lidhja e faqes kryesore të portalit",
          "ERROR": "URL e pavlefshme. Lidhja e faqes kryesore duhet të fillojë me 'http://' ose 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug i portalit"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget-i i bisedës live",
          "PLACEHOLDER": "Zgjidh widget-in e bisedës live",
          "HELP_TEXT": "Zgjidh një widget bisede live që do të shfaqet në qendrën tënde të ndihmës"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "I aksesueshëm publikisht",
          "HELP_TEXT": "Bëje portalin të aksesueshëm për këdo me lidhje.",
          "OPTIONS": {
            "PUBLIC": "Po",
            "PRIVATE": "Jo"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Objektivi i lidhjes",
          "HELP_TEXT": "Zgjidhni nëse lidhjet brenda artikujve hapen në dritaren aktuale apo në një të re.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Dritarja aktuale",
            "NEW_WINDOW": "Dritare e re"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Madhësia e parazgjedhur e imazhit",
          "HELP_TEXT": "Madhësia që zbatohet për çdo imazh që fut në një artikull. Zgjidh Original për të futur imazhet me madhësinë e tyre, ose zgjidh një madhësi për çdo imazh veç e veç."
        },
        "BRAND_COLOR": {
          "LABEL": "Ngjyra e markës"
        },
        "CUSTOM_HTML": {
          "LABEL": "HTML i personalizuar",
          "PLACEHOLDER": "<!-- Ngjit këtu kodin tënd të analitikës ose gjurmimit -->",
          "HELP_TEXT": "Futet në fillim të etiketës <body> në çdo faqe të qendrës së ndihmës. Përdoreni për Google Analytics, Google Tag Manager ose çdo kod tjetër gjurmimi. Kodi shfaqet saktësisht ashtu siç është shkruar dhe nuk validohet."
        },
        "SAVE_CHANGES": "Ruaj ndryshimet"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Domen i personalizuar",
          "LABEL": "Domen i personalizuar:",
          "DESCRIPTION": "Mund ta strehosh portalin tënd në një domen të personalizuar. Për shembull, nëse faqja jote është yourdomain.com dhe dëshiron që portali të jetë i disponueshëm te docs.yourdomain.com, thjesht vendose atë në këtë fushë.",
          "PLACEHOLDER": "Domeni i personalizuar i portalit",
          "EDIT_BUTTON": "Modifiko domenin e personalizuar",
          "ADD_BUTTON": "Shto domen të personalizuar",
          "DIALOG": {
            "ADD_HEADER": "Shto domen të personalizuar",
            "EDIT_HEADER": "Modifiko domenin e personalizuar",
            "ADD_CONFIRM_BUTTON_LABEL": "Shto domenin",
            "EDIT_CONFIRM_BUTTON_LABEL": "Përditëso domenin",
            "LABEL": "Domen i personalizuar",
            "PLACEHOLDER": "Domeni i personalizuar i portalit",
            "ERROR": "Domeni i personalizuar është i detyrueshëm"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Konfigurimi DNS",
            "DESCRIPTION": "Identifikohu në llogarinë që ke te ofruesi yt i DNS-së dhe shto regjistrin CNAME më poshtë për nëndomenin tënd.",
            "HELP_TEXT": "Pasi ta bësh këtë, mund të na kontaktosh mbështetjen për të kërkuar certifikatën SSL të gjeneruar automatikisht.",
            "CONFIRM_BUTTON_LABEL": "E kuptova!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Fshi {portalName}",
          "HEADER": "Fshi portalin",
          "DESCRIPTION": "Fshi përgjithmonë këtë portal. Ky veprim është i pakthyeshëm",
          "DIALOG": {
            "HEADER": "Je i sigurt që dëshiron të fshish {portalName}?",
            "DESCRIPTION": "Ky është një veprim i përhershëm që nuk mund të kthehet mbrapsht.",
            "CONFIRM_BUTTON_LABEL": "Fshi"
          }
        },
        "EDIT_CONFIGURATION": "Modifiko konfigurimin"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portali u krijua me sukses",
          "ERROR_MESSAGE": "Portali nuk u krijua dot"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portali u përditësua me sukses",
          "ERROR_MESSAGE": "Portali nuk u përditësua dot"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Bashkëngjitjet",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Shto skedar",
      "DROP_HERE": "Tërhiq dhe lësho skedarët këtu",
      "COPY_LINK": "Kopjo lidhjen",
      "LINK_COPIED": "Lidhja u kopjua në clipboard",
      "COPY_FAILED": "Kopjimi i lidhjes dështoi",
      "DELETE": "Fshi",
      "CANCEL": "Anulo",
      "QUEUED": "Në radhë",
      "UPLOADING": "Duke ngarkuar",
      "UPLOAD_FAILED": "Ngarkimi i skedarit dështoi",
      "FILE_TOO_LARGE": "Skedari tejkalon kufirin prej 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Fjalori i përkthimit",
        "DESCRIPTION": "Termat e përcaktuar këtu shtohen te udhëzimi (prompt) i përkthimit me AI, në mënyrë që të përkthehen gjithmonë në të njëjtën mënyrë. Termi kryesor është shkruar në {locale}."
      },
      "NEW_TERM": "Term i ri",
      "EMPTY_STATE": {
        "TITLE": "Ende pa terma në fjalor",
        "SUBTITLE": "Shto një term dhe përkthimin e tij për çdo gjuhë. Kur një artikull përkthehet, këto terma zbatohen në mënyrë që gjuha e produktit tënd të mbetet konsistente."
      },
      "LIST": {
        "TERM": "Termi",
        "TRANSLATIONS": "Përkthimet",
        "ACTIONS": "Veprime"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Shto term",
          "EDIT": "Modifiko termin",
          "DESCRIPTION": "Termi më poshtë zbatohet gjatë përkthimit me AI të artikujve të qendrës së ndihmës.",
          "PORTAL": "Portali",
          "PRIMARY_LANGUAGE": "Gjuha kryesore"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Termi ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Termi është i detyrueshëm"
          },
          "DESCRIPTION": {
            "LABEL": "Konteksti / shënime (opsionale)",
            "PLACEHOLDER": "Kur dhe si përdoret ky term, për ta ndihmuar përkthyesin të qartësojë kuptimin."
          },
          "TRANSLATIONS": "Përkthimet",
          "TRANSLATION_PLACEHOLDER": "Lëre bosh që AI-ja ta përkthejë lirshëm",
          "AUTO_TRANSLATE": {
            "BUTTON": "Përkthe automatikisht të gjitha",
            "CONFIRM": "Të përkthehet në {count} gjuhë me AI?",
            "CONFIRM_BUTTON": "Përkthe",
            "CANCEL": "Anulo",
            "SUCCESS": "Përkthimet u gjeneruan — shqyrto dhe ruaj",
            "ERROR": "Përkthimi automatik dështoi, provo përsëri"
          }
        },
        "BUTTONS": {
          "CREATE": "Shto term",
          "EDIT": "Ruaj",
          "CANCEL": "Anulo"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Termi u shtua me sukses",
            "ERROR_MESSAGE": "Termi nuk u shtua dot. Provo përsëri."
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Termi u përditësua me sukses",
            "ERROR_MESSAGE": "Termi nuk u përditësua dot. Provo përsëri."
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Fshi termin",
          "DESCRIPTION": "Je i sigurt që dëshiron ta fshish këtë term? Ai nuk do të zbatohet më gjatë përkthimit.",
          "CONFIRM": "Fshi"
        },
        "API": {
          "SUCCESS_MESSAGE": "Termi u fshi me sukses",
          "ERROR_MESSAGE": "Termi nuk u fshi dot. Provo përsëri."
        }
      }
    }
  }
}
